/*
 * Modo claro / oscuro.
 *
 * - Por defecto se sigue la configuración del dispositivo (prefers-color-scheme)
 *   y se actualiza en vivo si el usuario la cambia (p. ej. modo oscuro automático
 *   al anochecer).
 * - Si el visitante pulsa el botón de cambiar modo, su elección se guarda y
 *   tiene prioridad sobre la del dispositivo.
 */

const CLAVE = "theme"; // "dark" | "light" (elección manual); sin valor = seguir al sistema

const consultaSistema = () => (window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null);

function leerPreferencia() {
  try {
    const valor = localStorage.getItem(CLAVE);
    return valor === "dark" || valor === "light" ? valor : null;
  } catch (e) {
    return null;
  }
}

function aplicar(darkMode, store) {
  document.documentElement.classList.toggle("dark", darkMode);
  document.documentElement.style.colorScheme = darkMode ? "dark" : "light";
  if (store) store.commit("changeDarkMode", darkMode);
}

export function sistemaEnOscuro() {
  const mq = consultaSistema();
  return Boolean(mq && mq.matches);
}

// Se llama una vez al arrancar la app, antes de pintarla.
export function initTheme(store) {
  const preferencia = leerPreferencia();
  aplicar(preferencia ? preferencia === "dark" : sistemaEnOscuro(), store);

  const mq = consultaSistema();
  if (!mq) return;

  const alCambiarSistema = (e) => {
    // Solo manda el sistema mientras el usuario no haya elegido a mano
    if (!leerPreferencia()) aplicar(e.matches, store);
  };

  if (mq.addEventListener) mq.addEventListener("change", alCambiarSistema);
  else if (mq.addListener) mq.addListener(alCambiarSistema); // Safari < 14
}

// Botón de cambiar modo: invierte el actual y recuerda la elección.
export function toggleTheme(store) {
  const darkMode = !document.documentElement.classList.contains("dark");
  aplicar(darkMode, store);

  try {
    // Si la elección coincide con el sistema, se vuelve a "seguir al sistema"
    if (darkMode === sistemaEnOscuro()) localStorage.removeItem(CLAVE);
    else localStorage.setItem(CLAVE, darkMode ? "dark" : "light");
  } catch (e) {
    // localStorage no disponible
  }
  return darkMode;
}
